export default "__VITE_ASSET__CAmeHRDj__"